export default "__VITE_ASSET__BAhjwYmY__"